import { HeadCell } from "../../../../../component/table/interfaces/TableInterface";

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'PLACA', label: 'Veículo' },
  { id: 'SITUACAO', label: 'Situacão' },
  { id: 'destino', label: 'Destino' },
  { id: 'statusVeiculo', label: 'Status' },
];